/** Dialogs and menus, which own the keyboard while open. */
export const OVERLAY_SELECTOR =
  '[role="dialog"], [role="alertdialog"], [role="menu"], [role="listbox"]';

// A key inside an overlay is typing or a typeahead jump, not a board shortcut such as "c" or the peek's Space.
export function isInOverlay(event: KeyboardEvent): boolean {
  return (
    document.querySelector('[aria-modal="true"]') !== null ||
    (event.target instanceof Element &&
      event.target.closest(OVERLAY_SELECTOR) !== null)
  );
}

/** Create-task yields to overlays, and to a surface whose comment keys took the press. */
export function shouldIgnoreCreateTaskShortcut(event: KeyboardEvent): boolean {
  return event.defaultPrevented || isInOverlay(event);
}
